import { defineStore } from 'pinia'
import { livePanelStore } from '@/stores/socket/live-panel-socket.store'
import presence from '@/api/general/presence.api'
import { i18n } from '@/helpers/locale/locale.helper.js'
import { hasActiveFilter } from '@/helpers/live-panel/filter-extensions'
import offWorkIcon from '@/assets/images/icons/extensions/status/off-work.svg'
import available from '@/assets/images/components/dropdown/icons/available.svg'
import Away from '@/assets/images/components/dropdown/icons/away.svg'

export const usePresence = defineStore('presence', {
  state: () => ({
    presence: [],
    uiFlags: {
      isLoading: false
    },
    _livePanelStore: livePanelStore()
  }),
  getters: {
    getAll(state) {
      return state.presence
    },
    filterByStatusList(state) {
      return [
        ...state.presence,
        {
          id: 'unavailable',
          name: i18n.global.t('call_center.extensions_status_filter_list.inactive'),
          status: 'unavailable',
          sub_type: '',
          message: '',
          icon: offWorkIcon
        }
      ]
    },
    filteredFilterByStatusList(state) {
      const filter = state._livePanelStore.filter
      if (!hasActiveFilter(filter) || !('status' in filter)) {
        return []
      }
      if (filter.status === undefined) {
        return state.filterByStatusList
      }
      return state.filterByStatusList.filter((item) => filter.status.includes(item.id))
    },
    currentUserPresence(state) {
      return state.getExtensionPresence(state._livePanelStore.currentUserExtension.number)
    }
  },
  actions: {
    async getPresence() {
      this.uiFlags.isLoading = true
      try {
        const response = await presence.get()
        this.presence = response.data.data

        this.presence.forEach((status) => {
          status.icon = status.image ?? (status.name == 'Available' ? available : Away)
        })
      } catch (e) {
        throw new Error(e)
      } finally {
        this.uiFlags.isLoading = false
      }
    },
    async setPresence(data) {
      try {
        await presence.create(data, 'store')
      } catch (e) {
        throw new Error(e)
      } finally {
        this.uiFlags.isLoading = false
      }
    },
    async deletePresence(data) {
      try {
        await presence.delete(data, 'delete')
      } catch (e) {
        throw new Error(e)
      } finally {
        this.uiFlags.isLoading = false
      }
    },
    getExtensionPresence(extension) {
      return this.getAll.find((presence) => {
        switch (presence.status.toLowerCase()) {
          case 'available':
          case 'unavailable':
          case 'xa':
          case 'chat':
          case 'dnd':
            return (
              presence.status.toLowerCase() ===
              this._livePanelStore.getAgentPresence(extension)?.status.toLowerCase()
            )
          default:
            return (
              presence.status.toLowerCase() ===
                this._livePanelStore.getAgentPresence(extension)?.status.toLowerCase() &&
              presence.sub_type.toLowerCase() ===
                this._livePanelStore.getAgentPresence(extension)?.subType.toLowerCase()
            )
        }
      })
    }
  }
})
